/*
 * サブシステム名：作業実績
 * 機能名：作業実績一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDataTable from '@/components/DdDataTable'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTextBox from '@/components/DdTextBox'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'

const IMAGE_EXTENTION_LIST = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'gif', 'GIF', 'bmp', 'BMP']

export default {
  name: 'JissekiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {},
    searchText: '',
    modeKengen: 0,
    page: 1,
    isLoading: false,

    // ヘッダー定義
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,

    // 表示制御
    isFixedTokuisaki: false,
    isShowAllRequest: true,
    // ボタン制御
    isCheckSheetBatchDownload: false,
    isExcelBatchDownload: false,

    // ページネーション用
    vItemsPerPage: 100,
    vPage: 1
  }),
  components: {
    DdCustomButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDataTable,
    DdDateRangeBox,
    DdDropDown,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      jininList: 'DDMasters/mstJinin',
      eigyoshoList: 'DDMasters/mstEigyosho',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      loginUserId: 'users/userId',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.filter((elem) => {
        if (!this.isShowAllRequest && elem.checksheetCount <= 0) return false
        return true
      }).map((elem) => {
        // 表示用作業依頼日作成
        var sagyoYoteiYmdFromDisp = elem.sagyoYoteiYmdFrom ? (filter.dateFormatter(elem.sagyoYoteiYmdFrom)) : ''
        var sagyoYoteiYmdToDisp = elem.sagyoYoteiYmdTo ? '～' + (filter.dateFormatter(elem.sagyoYoteiYmdTo)).slice(-5) : ''
        var sagyoYoteiYmdDisp = sagyoYoteiYmdFromDisp + sagyoYoteiYmdToDisp

        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.sagyoYoteiYmdDisp = sagyoYoteiYmdDisp
        elem2.jissekiSagyoYmdDisp = elem.jissekiSagyoYmd ? (filter.dateFormatter(elem.jissekiSagyoYmd)) : ''
        elem2.sagyoCancelYmdDisp = elem.sagyoCancelYmd ? (filter.dateFormatter(elem.sagyoCancelYmd)) : ''
        elem2.sagyoYmdDisp = elem.sagyoCancelFlg ? elem2.sagyoCancelYmdDisp : elem2.jissekiSagyoYmdDisp
        elem2.sagyoStatus = elem.completeCnt + ' / ' + elem.sharyoCnt

        // チェックシート情報
        if (![undefined, null].includes(elem2.sagyoImage)) {
          elem2.checkSheetList = elem2.sagyoImage.filter(item => {
            return item.sagyoImageKbn === '01'
          }).map((item, index) => {
            item.index = index + 1
            const sagyoImageFileNmSplit = (item.sagyoImageFileNm ?? '').split('.')
            const sagyoImageFileExtention = sagyoImageFileNmSplit[sagyoImageFileNmSplit.length - 1]
            item.content = `/api/v1/trTgSagyoImage/Image?id=${item.id}&date=${new Date()}`
            item.fileKbn = IMAGE_EXTENTION_LIST.includes(sagyoImageFileExtention) ? 'img' : 'noImg'

            // ファイル名作成用
            item.sagyoKbnNm = elem.sagyoKbnNm
            item.newShabanPlateNo = elem.newShabanPlateNo

            return item
          })
        }
        elem2.checksheetCnt = [undefined, null].includes(elem2.checkSheetList) ? 0 : elem2.checkSheetList.length

        // 領収書情報
        if (![undefined, null].includes(elem2.sagyoImage)) {
          elem2.receiptList = elem2.sagyoImage.filter(item => {
            return item.sagyoImageKbn === '04'
          }).map((item, index) => {
            item.index = index + 1
            const sagyoImageFileNmSplit = (item.sagyoImageFileNm ?? '').split('.')
            const sagyoImageFileExtention = sagyoImageFileNmSplit[sagyoImageFileNmSplit.length - 1]
            item.content = `/api/v1/trTgSagyoImage/Image?id=${item.id}&date=${new Date()}`
            item.fileKbn = IMAGE_EXTENTION_LIST.includes(sagyoImageFileExtention) ? 'img' : 'noImg'

            // ファイル名作成用
            item.sagyoKbnNm = elem.sagyoKbnNm
            item.newShabanPlateNo = elem.newShabanPlateNo

            return item
          })
        }
        elem2.receiptCnt = [undefined, null].includes(elem2.receiptList) ? 0 : elem2.receiptList.length
        elem2.receiptKingakuKeiDisp = [undefined, null, ''].includes(elem.receiptKingakuKei) ? null : filter.numericFormatter(elem.receiptKingakuKei)

        return elem2
      })
    },
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 商品名
    filteredShohinList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.hinshuSbt === '01' && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    // 作業区分
    filteredSagyoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'TGK001')
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    getUserInfo: function () {
      const target = filter.dateFormatter(new Date())
      const jininInfo = indexeddb.getRecord(this.jininList, this.loginUserId)
      const eigyoshoInfo = indexeddb.getRecordByCd('0010', this.eigyoshoList, 'eigyoshoCd', jininInfo.eigyoshoCd, target)
      if (eigyoshoInfo && eigyoshoInfo.eigyoshoKbn === '04') {
        const tokuisaki = indexeddb.getRecordByCd('0010', this.torihikisakiList, 'torihikisakiCd', jininInfo.renkeiText1, target)
        if (tokuisaki) {
          this.conditions.parentTokuisakiId = tokuisaki.id
        }
        this.isFixedTokuisaki = true
      }
    },
    setHeaders: function () {
      this.headers = [
        { text: '', value: 'data-table-select', width: '42px' },
        { text: 'ステータス', value: 'status' },
        { text: '注文番号', value: 'chumonNo' },
        { text: '顧客管理番号', value: 'oyaDenpyoNo' },
        { text: '取付先', value: 'toritsukesaki' },
        { text: '営業所', value: 'toritsukesakiEigyosho' },
        { text: '台数(完了/依頼)', value: 'sagyoStatus', align: 'center', sortable: false },
        { text: '車番プレートNo', value: 'newShabanPlateNo' },
        { text: '作業予定日', value: 'sagyoYoteiYmdDisp' },
        { text: '作業日', value: 'sagyoYmdDisp', align: 'center' },
        { text: 'チェックシートリンク', value: 'checksheetLink' }
      ]
      if (!this.isFixedTokuisaki) {
        this.headers.push({ text: '領収書リンク', value: 'receiptLink' })
        this.headers.push({ text: '領収書合計額', value: 'receiptKingakuKeiDisp' })
      }
      this.headers.push({ text: '作業', value: 'sagyoKbnNm' })
      this.headers.push({ text: '商品', value: 'shohinNm' })
      if (!this.isFixedTokuisaki) {
        this.headers.push({ text: '顧客', value: 'tokuisakiNm' })
      }
      this.headers.push({ text: '連絡事項', value: 'iraisakiRenrakuMemo' })
    },
    initialize: function () {
      this.widthOfLineHeader = [0, 0, 0, 0, 0, 0, 0, 0, 0]
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'msteigyosho', 'msyskubun', 'mstshubetsu', 'msthinmei'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              tokuisakiId: null,
              parentTokuisakiId: null,
              toritsukesaki: null,
              toritsukesakiEigyosho: null,
              sagyoStartYmdString: self.setFromDate(-14),
              sagyoEndYmdString: null,
              oyaDenpyoNo: null,
              chumonNo: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              sagyoReceiptFlg: true,
              sagyoRequestFlg: true,
              sagyoJisshiFlg: true,
              sagyoKanryoFlg: true,
              sagyoCancelFlg: true,
              checkSheetExistFlg: true,
              checkSheetNotExistFlg: true
            }
            self.getUserInfo()
            self.setHeaders()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGRCOD0010.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
          }
          console.log('TGRCOD0010.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGRCOD0010.researchPromise', c)
          // modals.showToast('検索中です。しばらくお待ちください。', 1500, 550, 'top-end', 'info')
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.$nextTick(() => { self.isLoading = false })
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGRCOD0010.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
              self.$nextTick(() => { self.isLoading = false })
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.vPage = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.isLoading = true

          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCTgprmd00100/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.isLoading = false
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 作業日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.sagyoStartYmdString, this.conditions.sagyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            self.conditions = {
              tokuisakiId: null,
              parentTokuisakiId: null,
              toritsukesaki: null,
              toritsukesakiEigyosho: null,
              sagyoStartYmdString: self.setFromDate(-14),
              sagyoEndYmdString: null,
              oyaDenpyoNo: null,
              sagyoKbn: null,
              shohinId: null,
              newShabanPlateNo: null,
              sagyoReceiptFlg: true,
              sagyoRequestFlg: true,
              sagyoJisshiFlg: true,
              sagyoKanryoFlg: true,
              sagyoCancelFlg: true,
              checkSheetExistFlg: true,
              checkSheetNotExistFlg: true
            }
            self.getUserInfo()
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.vPage = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    saveConditionToCache: function () {
      const cache = {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
      this.saveToChache(cache)
    },

    /* ================================================================================ *
     * 写真
     * ================================================================================ */
    onImageOpenButtonClick: function (item) {
      if (item && item.content) {
        if (item.fileKbn === 'img') {
          window.open(item.content)
        } else {
          this.onSagyoImagePdfOtherWindow(item)
        }
      }
    },
    onImageDownloadButtonClick: function (item) {
      if (item && item.content) {
        if (item.fileKbn === 'img') {
          window.open(item.content)
        } else {
          this.onSagyoImagePdfDownload(item)
        }
      }
    },
    onSagyoImagePdfOtherWindow: function (item) {
      return new Promise((resolve) => {
        this.HttpClient
          .requestFile(`/api/v1/trTgSagyoImage/Pdf?id=${item.id}`)
          .then((data) => {
            const tabName = item.newShabanPlateNo.replaceAll('\t', ' ') + '-' + item.sagyoImageNo
            var blob = new Blob([data], {
              type: 'application/pdf'
            })
            const fileURL = URL.createObjectURL(blob)
            var w1
            w1 = window.open('', '_blank')
            w1.document.open()
            w1.document.write('<html>')
            w1.document.write('<head><title>' + tabName + '</title></head>')
            w1.document.write('<frameset><frame src="' + fileURL + '"></frameset>')
            w1.document.write('</html>')
            w1.document.close()
            resolve()
          })
          .catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            resolve()
          })
      })
    },
    onSagyoImagePdfDownload: function (item) {
      return new Promise((resolve) => {
        this.HttpClient
          .requestFile(`/api/v1/trTgSagyoImage/Pdf?id=${item.id}`)
          .then((data) => {
            console.log(data)
            const fileName = item.newShabanPlateNo.replaceAll('\t', ' ') + '-' + item.sagyoImageNo + '.pdf'
            const blob = new Blob([data], { type: 'application/octet-stream' })
            const elem = document.getElementById('sagyoImageDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.target = '_blank'
            elem.download = fileName
            elem.click()
          })
          .catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            resolve()
          })
      })
    },

    // 一括DL
    onClickCheckSheetSpecifiedDownLoad: function () {
      const self = this
      this.isCheckSheetBatchDownload = true

      // 更新情報作成
      var sagyoMeisaiIdList = []
      this.selected.forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const idList = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (idList.length === 0) return

      this.Effects.loadStart()

      function specifiedDownloadPromise (idList) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgprmd0100/CheckSheetSpecifiedDownload', idList)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const zipFileNmae = 'チェックシート' + '_' + ts + '.zip'
              const blob = new Blob([data], { type: 'application/zip' })
              const elem = document.getElementById('batchDownload')
              self.isCheckSheetBatchDownload = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = zipFileNmae
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(idList).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された車両のチェックシートをダウンロードしました')
      })
    },

    onClickOutputExcelSpecifiedDownLoad: function () {
      const self = this
      this.isExcelBatchDownload = true

      // 更新情報作成
      var sagyoMeisaiIdList = []
      this.selected.forEach((x) => {
        sagyoMeisaiIdList.push(x.id)
      })
      const idList = {
        trSagyoMeisaiId: sagyoMeisaiIdList
      }

      if (idList.length === 0) return

      this.Effects.loadStart()
      function specifiedDownloadPromise (idList) {
        return new Promise(function (resolve) {
          self.HttpClient
            .requestFileByPost('/api/v1/Tgprmd0100/ExcelOutput', idList)
            .then((data) => {
              const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
              const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              const elem = document.getElementById('batchDownload')
              self.isExcelBatchDownload = false
              elem.href = window.URL.createObjectURL(blob)
              elem.download = '作業実績一覧_' + ts + '.xlsx'
              elem.click()
              resolve(data)
            })
        })
      }
      specifiedDownloadPromise(idList).then(() => {
        self.Effects.loadComplete()
        modals.showSuccess('選択された車両の一覧をダウンロードしました')
      })
    },

    setFromDate: function (num) {
      var date = new Date()
      date.setDate(date.getDate() + num)

      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },

    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      if (this.filteredRows.length === 0) return
      this.vItemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      if (this.filteredRows.length === 0) return
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vItemsPerPage, this.vPage)
      })
    }
  }
}
